module.exports = __webpack_public_path__ + "static/boxes-b06b4ba817a29b84feaade57e695f4e9.png";